module.exports = __webpack_public_path__ + "img/dream-journal_B095GDFB4C.39e67599.jpg";